import { SubmissionError, initialize, reset, submit, destroy, registerField, unregisterField, change, clearSubmitErrors, clearFieldErrors, setSubmitFailed, setFieldErrors, stopSubmit, setSubmitSucceeded, untouch } from 'redux-form'

import { ShowWarningDispatch, ShowErrorDispatch } from './ShowNotificationActions'
import _ from 'common-tools/LodashHelper'
import { log, convertMessageErrorsToFormErrors } from 'common-tools/index'

const ShowWarning = ShowWarningDispatch()
const ShowError = ShowErrorDispatch()

export const formInitValues = (dispatch) => {
  return (formName, data) => {
    dispatch(initialize(formName, data, {
      keepDirty: true,
      keepSubmitSucceeded: true,
      updateUnregisteredFields: true,
      keepValues: true
    }))
  }
}

export const formResetValues = (dispatch) => {
  return (formName) => {
    dispatch(reset(formName))
  }
}

export const formSubmit = (dispatch) => {
  return (formName) => {
    dispatch(submit(formName))
  }
}

export const formDestroy = (dispatch) => {
  return (formName) => {
    dispatch(destroy(formName))
  }
}

export const formRegisterField = (dispatch) => {
  return (formName, fieldName) => {
    dispatch(registerField(formName, fieldName, 'Field'))
  }
}

export const formRegisterFieldArray = (dispatch) => {
  return (formName, fieldName) => {
    dispatch(registerField(formName, fieldName, 'FieldArray'))
  }
}

export const formUnregisterField = (dispatch) => {
  return (formName, fieldName) => {
    dispatch(unregisterField(formName, fieldName))
  }
}

export const formSetFieldValue = (dispatch) => {
  return (formName, fieldName, value) => {
    dispatch(change(formName, fieldName, value))
  }
}

export const formStopSubmit = (dispatch) => {
  return (formName, errors) => {
    dispatch(stopSubmit(formName, errors))
    const fields = _.keys(errors)
    if (!_.isEmpty(errors)) {
      dispatch(setSubmitFailed(formName, ...fields))
      ShowWarning('Validation Failed!')
    }
  }
}

export const formResetFieldStates = (dispatch) => {
  return (formName, fieldNames) => {
    dispatch(untouch(formName, fieldNames))
  }
}

export const formSetValidationFailed = (dispatch) => {
  return (formName, fieldNames) => {
    dispatch(setSubmitFailed(formName, fieldNames))
  }
}

export const formThrowSubissionError = (dispatch) => {
  return (errors) => {
    throw new SubmissionError(errors)
  }
}

export const formSetErrors = (dispatch) => {
  return (errors) => {
    if (_.isPlainObject(errors) === true && _.isEmpty(errors) === false) {
      ShowWarning('Validation Failed!')
      throw new SubmissionError(errors)
    }
  }
}

export const formSetValidation = (dispatch) => {
  return (formName, errors = {}, fieldNames) => {
    dispatch(stopSubmit(formName, errors))
    if (_.isArray(fieldNames)) {
      dispatch(setSubmitFailed(formName, ...fieldNames))
    } else {
      const fields = _.keys(errors)
      if (fields.length > 0) {
        dispatch(setSubmitFailed(formName, ...fields))
      }
    }
  }
}

export const formClearValidation = (dispatch) => {
  return (formName) => {
    dispatch(clearSubmitErrors(formName))
    dispatch(setSubmitSucceeded(formName))
  }
}

export const formClearValidationFields = (dispatch) => (formName, fieldNames) => {
  dispatch(clearFieldErrors(formName, fieldNames))
}

export const formSetValidationFields = (dispatch) => (formName, fields) => {
  dispatch(setFieldErrors(formName, fields))
}

export const formCheckForSubmissionErrors = (dispatch) => {
  return (error, throwEx = true) => {
    var ret = convertMessageErrorsToFormErrors(error)

    if (ret) {
      if (ret.success === false) {
        if (throwEx === true) {
          throw new SubmissionError({
            _error: 'Submit Failed!'
          })
        } else {
          return ret.data
        }
      } else {
        ShowWarning('Validation Failed!')
        if (throwEx === true) {
          throw new SubmissionError(ret.data)
        } else {
          return ret
        }
      }
    }
  }
}

export const formShowSubmissionErrors = (dispatch) => {
  return (error) => {
    if (_.isArray(error) === false) {
      log.Error('Submission Non Array Error', { Error: error })
      // some other error, just need to throw submission error
      ShowError('Submit Failed!  Error is not Collection')
    }

    let validationErrors = _.filter(error, { Type: 'Rule' })

    if (validationErrors.length > 0) {
      _.each(validationErrors, (ve) => {
        ShowWarning(ve.Message)
      })
    }
  }
}

export const formGetSubmissionErrors = (dispatch) => {
  return (error) => {
    if (_.isArray(error) === false) {
      log.Error('Submission Non Array Error', { Error: error })
      // some other error, just need to throw submission error
      return [{ Message: 'Submit Failed!  Error is not Collection', Type: 'Error' }]
    }
    if (error.length > 0) {
      return _.map(error, (ve) => {
        return ve
      })
    } else {
      return []
    }
  }
}
